import { Index, type JSX, Show } from 'solid-js';
import { t } from '../../i18n';
import type { CapabilitySwitches as Caps } from '../../lib/capability-switches';
import type { CapZoneView } from '../../lib/machine-capabilities';
import { CAP_NAME_KEY } from '../../lib/machine-capabilities';
import { CapabilityAsk } from './CapabilityAsk';
import { CapabilitySwitch } from './CapabilitySwitch';
import { ControlLock } from './ControlLock';

// The Capabilities zone's switches (#6766, prototype capGrid + askHTML): the page lock's
// one line above them (#6753's `ControlLock`, deviation 5: no lock words of their own), the
// nine switches in the card's order, and the ask when a running role is turned off. Mounted
// by `CapabilitiesZone` only for an admin on an own-org machine whose read carries `roles`.
// `Index`, not `For`: the view is rebuilt on every guard tick, and a switch must keep its node
// (and its focus) while its state changes.

export function CapabilitySwitches(props: {
  readonly caps: Caps;
  readonly zone: CapZoneView;
}): JSX.Element {
  return (
    <>
      <ControlLock />
      <div class="mission-sw-grid">
        <Index each={props.zone.switches}>
          {(sw) => <CapabilitySwitch sw={sw()} onToggle={() => props.caps.toggle(sw().key)} />}
        </Index>
      </div>
      <Show when={props.caps.ask()} keyed>
        {(a) => (
          <CapabilityAsk
            name={t(CAP_NAME_KEY[a.key])}
            jobs={a.jobs}
            onYes={() => props.caps.confirm()}
            onNo={() => props.caps.cancel()}
          />
        )}
      </Show>
    </>
  );
}
